import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=7e257c16&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=7e257c16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e257c16",
  null
  
)

export default component.exports